// Wishlist manager folosind localStorage
const Wishlist = {
  key: 'divanoff_wishlist',

  getItems() {
    try {
      return JSON.parse(localStorage.getItem(this.key)) || [];
    } catch { return []; }
  },

  saveItems(items) {
    localStorage.setItem(this.key, JSON.stringify(items));
  },

  add(productId, productData) {
    const items = this.getItems();
    if (!items.find(i => i.id === productId)) {
      items.push({ id: productId, ...productData, addedAt: Date.now() });
      this.saveItems(items);
    }
    this.updateUI();
  },

  remove(productId) {
    const items = this.getItems().filter(i => i.id !== productId);
    this.saveItems(items);
    this.updateUI();
    document.dispatchEvent(new CustomEvent('wishlist:removed', { detail: { id: productId } }));
  },

  toggle(productId, productData) {
    if (this.has(productId)) {
      this.remove(productId);
      return false;
    } else {
      this.add(productId, productData);
      return true;
    }
  },

  has(productId) {
    return this.getItems().some(i => i.id === productId);
  },

  count() {
    return this.getItems().length;
  },

  updateUI() {
    // Update count bubbles
    const count = this.count();
    ['wishlist-count-bubble-desktop', 'wishlist-count-bubble-mobile'].forEach(id => {
      const bubble = document.getElementById(id);
      if (!bubble) return;
      const countEl = bubble.querySelector('span[aria-hidden]');
      if (countEl) countEl.textContent = count;
      bubble.style.display = count > 0 ? 'flex' : 'none';
    });

    // Update button states pe pagina de produs
    document.querySelectorAll('[data-wishlist-btn]').forEach(btn => {
      const id = btn.dataset.productId;
      if (id) {
        const active = this.has(parseInt(id));
        btn.classList.toggle('is-wishlisted', active);
        btn.setAttribute('aria-label', active ? 'Elimină din wishlist' : 'Adaugă în wishlist');
        const svg = btn.querySelector('svg');
        if (svg) svg.style.fill = active ? 'currentColor' : 'none';
        const label = btn.querySelector('.wishlist-btn__label');
        if (label) label.textContent = active ? 'Salvat' : 'Salvează';
      }
    });

    // Update header icon
    document.querySelectorAll('.header__icon--wishlist').forEach(el => {
      el.classList.toggle('wishlisted', count > 0);
    });
  }
};

// Inițializare la load
document.addEventListener('DOMContentLoaded', () => {
  Wishlist.updateUI();

  // Click pe butoanele wishlist
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-wishlist-btn]');
    if (!btn) return;
    e.preventDefault();

    const productId = parseInt(btn.dataset.productId);
    const productData = {
      title: btn.dataset.productTitle || '',
      price: btn.dataset.productPrice || '',
      image: btn.dataset.productImage ? (btn.dataset.productImage.startsWith('//') ? 'https:' + btn.dataset.productImage : btn.dataset.productImage) : '',
      url: btn.dataset.productUrl || '',
      vendor: btn.dataset.productVendor || ''
    };

    const added = Wishlist.toggle(productId, productData);

    // Animație feedback
    btn.classList.add('wishlist-btn--animating');
    setTimeout(() => btn.classList.remove('wishlist-btn--animating'), 300);
  });
});

window.Wishlist = Wishlist;